export type MigratedCustomPageSlug = 'faq' | 'schedule' | 'story' | 'vip' | 'welcome';
export type CreateEventFeature =
  | 'useWebsiteDesignerV3'
  | 'bypassWebsiteThemeCustomization'
  | 'useStoryAsCustomPage'
  | 'useFaqAsCustomPage'
  | 'useVipAsCustomPage'
  | 'useWelcomeAsCustomPage'
  | 'useScheduleAsCustomPage'
  | 'useGuestPageContentRedesign';

export const MIGRATED_PAGE_TO_EVENT_FEATURE_FLAG: Readonly<Record<MigratedCustomPageSlug, CreateEventFeature>> = {
  story: 'useStoryAsCustomPage',
  faq: 'useFaqAsCustomPage',
  vip: 'useVipAsCustomPage',
  welcome: 'useWelcomeAsCustomPage',
  schedule: 'useScheduleAsCustomPage',
};
